/**
 * Calendar-date helpers for field_start_date policy (client local timezone).
 *
 * Generic calendar-date helpers now live in ./calendarDate and are
 * re-exported here so existing imports keep working.
 */

export {
  getTodayCalendarYmd,
  parseCalendarYmd,
  parseLocalCalendarDate,
  addCalendarDays,
  getCurrentWeekMondayYmd,
} from './calendarDate';

export const MAX_FIELD_START_DATE_YEARS_AHEAD = 3;

export const FIELD_START_DATE_TOO_FAR_FUTURE_MESSAGE =
  'Field installation start date cannot be set more than 3 years in the future. Please check the date and try again.';

/** Latest allowed field_start_date (today + MAX_FIELD_START_DATE_YEARS_AHEAD calendar years). */
export function getMaxFieldStartDateCalendarYmd() {
  const n = new Date();
  n.setFullYear(n.getFullYear() + MAX_FIELD_START_DATE_YEARS_AHEAD);
  const y = n.getFullYear();
  const m = String(n.getMonth() + 1).padStart(2, '0');
  const d = String(n.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** True if ymd is strictly after the maximum allowed future field_start_date. */
export function isCalendarDateBeyondMaxFieldStartAhead(ymd) {
  if (!ymd) return false;
  return ymd > getMaxFieldStartDateCalendarYmd();
}
